
import { defineComponent } from 'vue';
export default defineComponent({
  name: 'customizeView',
  inheritAttrs: false,
  props: {
    estimateAmount: {
      type: Number,
      required: false
    },
    promotionAmount: {
      type: Number,
      required: false
    }
  },
  methods: {
    openUrl() {
      window.open('https://fxit-dhb-tjb.oss-cn-hangzhou.aliyuncs.com/upload/ariesPreUat/2025/04/11/测试111_1744352851756.xlsx', '_blank');
    }
  }
});
